export const REQUEST_SEARCH_INCIDENT_TYPES =
  "places/REQUEST_SEARCH_INCIDENT_TYPES";
export const REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS =
  "places/REQUEST_SEARCH_INCIDENT_TYPES_SUCCESS";
export const REQUEST_SEARCH_INCIDENT_TYPES_FAIL =
  "places/REQUEST_SEARCH_INCIDENT_TYPES_FAIL";
